/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import PropTypes from 'prop-types';
import React from 'react';
import './loader.css';

class PageLoader extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isLoading: true,
  };

  render() {
    const { pastDelay, status } = this.props;

    return (
      <>
        {pastDelay && (
          <div id='loader'>
            <div className='bg' />
            <div className='lds-ring'>
              <div />
              <div />
              <div />
              <div />
            </div>
            {status && status}
          </div>
        )}
      </>
    );
  }
}

export default PageLoader;
